<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="点名转盘"
      :width="selectedCount >= 2 ? '1400px' : '1000px'"
      :close-on-click-modal="true"
      @close="handleClose">
    <div class="lucky-draw-container">
      <div class="main-content">
        <div class="left-content">
          <div class="count-control">
            <div class="count-label">点名人数：</div>
            <el-input-number 
              v-model="selectedCount" 
              :min="1" 
              :max="maxCount" 
              :step="1"
              size="medium"
              :disabled="isSpinning"
              @change="updatePointers"
              style="width: 120px; margin-right: 10px;"
            />
            <el-button 
              size="medium" 
              @click="decreaseCount"
              :disabled="selectedCount <= 1 || isSpinning"
              style="padding: 12px 16px; font-size: 16px;">
              -10
            </el-button>
            <el-button 
              size="medium" 
              @click="increaseCount"
              :disabled="selectedCount >= maxCount || isSpinning"
              style="padding: 12px 16px; font-size: 16px;">
              +10
            </el-button>
          </div>
          
          <div class="exclude-control">
            <el-button 
              size="medium" 
              @click="excludeCurrentStudents"
              :disabled="isSpinning || !hasStarted || selectedStudents.length === 0 || displayStudents.length <= 1"
              style="padding: 12px 20px; font-size: 16px;">
              排除当前学生
            </el-button>
            <el-button 
              size="medium" 
              @click="showExcludedListDialog = true"
              :disabled="excludedStudentIds.length === 0"
              style="padding: 12px 20px; font-size: 16px;">
              被排除学生列表 ({{ excludedStudentIds.length }})
            </el-button>
          </div>
          
          <div class="result-display" :style="{ background: subjectGradient }">
            <div v-if="selectedCount === 1" class="result-single">
              <div class="result-label">选中学生：</div>
              <div class="result-name">{{ hasStarted ? (selectedStudent ? (selectedStudent.studentNumber ? `${selectedStudent.studentNumber}. ${selectedStudent.name}` : selectedStudent.name) : '未开始') : '未开始' }}</div>
            </div>
            <div v-else class="result-multiple">
              <div class="result-label">选中学生：</div>
              <div class="result-list">
                <div 
                  v-for="(student, index) in selectedStudents" 
                  :key="index"
                  class="result-item">
                  <span 
                    class="pointer-color" 
                    :style="{ backgroundColor: pointerColors[index % pointerColors.length] }">
                  </span>
                  <span class="result-name">{{ hasStarted ? (student ? (student.studentNumber ? `${student.studentNumber}. ${student.name}` : student.name) : '未开始') : '未开始' }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div v-if="warningMessage" class="warning-message">{{ warningMessage }}</div>
          
          <div class="controls">
            <el-button 
              type="primary" 
              size="large" 
              @click="toggleSpin"
              style="padding: 15px 40px; font-size: 20px; min-width: 150px; border-radius: 15px;">
              {{ isSpinning ? '停止' : '开始' }}
            </el-button>
            <el-button 
              size="large" 
              @click="reset"
              style="padding: 15px 40px; font-size: 20px; min-width: 150px; border-radius: 15px;">
              重置
            </el-button>
          </div>
          <div class="tips">提示：点击按钮或拖动转盘转动，点击按钮或转盘停止</div>
        </div>
        
        <div class="right-content">
          <div class="wheel-wrapper">
            <canvas ref="wheelCanvas" width="500" height="500" class="wheel-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  
  <el-dialog
    :visible.sync="showExcludedListDialog"
    title="被排除学生列表"
    width="600px"
    :close-on-click-modal="true">
    <div class="excluded-list-container">
      <div v-if="excludedStudents.length === 0" class="empty-state">
        暂无被排除的学生
      </div>
      <div v-else class="excluded-list">
        <div 
          v-for="student in excludedStudents" 
          :key="student.id"
          class="excluded-student-item">
          <div class="student-info">
            <span class="student-number">{{ student.studentNumber ? student.studentNumber : '' }}</span>
            <span class="student-name">{{ student.name }}</span>
          </div>
          <el-button 
            size="small" 
            type="primary"
            @click="restoreStudent(student.id)">
            恢复
          </el-button>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="showExcludedListDialog = false">关闭</el-button>
      <el-button 
        v-if="excludedStudents.length > 0"
        type="primary"
        @click="restoreAllStudents">
        全部恢复
      </el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LuckyDrawDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    students: {
      type: Array,
      default: () => []
    },
    subjectIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      rotation: 0,
      speed: 0,
      isSpinning: false,
      isDragging: false,
      lastMouseAngle: 0,
      lastMouseTime: 0,
      lastMouseSpeed: 0,
      selectedStudent: null,
      selectedStudents: [],
      selectedCount: 1,
      pointerAngles: [],
      hasStarted: false,
      excludedStudentIds: [],
      showExcludedListDialog: false,
      warningMessage: '',
      originalStudents: [],
      pointerColors: [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', 
        '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
        '#BB8FCE', '#85C1E9', '#F8B500', '#00CED1'
      ],
      colors: [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', 
        '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
        '#BB8FCE', '#85C1E9', '#F8B500', '#00CED1'
      ],
      animationId: null,
      boundEvents: null,
      lastDrawTime: 0,
      drawInterval: 16
    };
  },
  computed: {
    subjectGradient() {
      const gradients = [
        'linear-gradient(90deg, #d2691e, #ff8c00)',
        'linear-gradient(90deg, #409EFF, #4169e1)',
        'linear-gradient(90deg, #ff69b4, #ff1493)'
      ];
      return gradients[this.subjectIndex] || gradients[0];
    },
    maxCount() {
      return Math.max(1, this.students.length - 1);
    },
    displayStudents() {
      if (this.excludedStudentIds.length > 0) {
        return this.students.filter(s => !this.excludedStudentIds.includes(s.id));
      } else {
        return this.students;
      }
    },
    excludedStudents() {
      return this.originalStudents.filter(s => this.excludedStudentIds.includes(s.id));
    }
  },
  watch: {
            visible(newVal) {
              this.dialogVisible = newVal;
              if (newVal) {
                this.$nextTick(() => {
                  this.reset();
                  this.updatePointers();
                  this.setupWheelEvents();
                });
              }
            },
            dialogVisible(newVal) {
              this.$emit('update:visible', newVal);
            },
            students(newVal) {
              if (newVal && newVal.length > 0) {
                this.originalStudents = [...newVal];
              }
              if (this.dialogVisible) {
                this.reset();
                this.updatePointers();
              }
            }
          },
  methods: {
    drawWheel() {
      const canvas = this.$refs.wheelCanvas;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 20;
      
      const displayStudents = this.displayStudents;
      if (displayStudents.length === 0) return;
      
      const anglePerStudent = (2 * Math.PI) / displayStudents.length;
      
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      displayStudents.forEach((student, index) => {
        const startAngle = index * anglePerStudent + this.rotation;
        const endAngle = startAngle + anglePerStudent;
        
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        
        ctx.fillStyle = this.colors[index % this.colors.length];
        ctx.fill();
        
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();
        
        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate(startAngle + anglePerStudent / 2);
        ctx.textAlign = 'right';
        ctx.fillStyle = '#fff';
        ctx.font = 'bold 14px Arial';
        
        const studentInfo = student.studentNumber ? `${student.studentNumber}. ${student.name}` : student.name;
        const maxLength = 12;
        const displayInfo = studentInfo.length > maxLength ? studentInfo.substring(0, maxLength) : studentInfo;
        ctx.fillText(displayInfo, radius - 30, 5);
        
        ctx.restore();
      });
      
      this.drawCenterCircle(ctx, centerX, centerY, 30);
      this.drawPointers(ctx, centerX, centerY, radius);
    },
    
    drawCenterCircle(ctx, x, y, radius) {
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, 2 * Math.PI);
      ctx.fillStyle = '#fff';
      ctx.fill();
      ctx.strokeStyle = '#333';
      ctx.lineWidth = 2;
      ctx.stroke();
    },
    
    drawPointers(ctx, centerX, centerY, wheelRadius) {
      const pointerCount = this.selectedCount;
      
      if (pointerCount === 1) {
        const angle = 0;
        const color = this.pointerColors[0];
        this.drawPointer(ctx, centerX, centerY, wheelRadius, angle, color);
      } else {
        for (let i = 0; i < pointerCount; i++) {
          const angle = this.pointerAngles[i];
          const color = this.pointerColors[i % this.pointerColors.length];
          this.drawPointer(ctx, centerX, centerY, wheelRadius, angle, color);
        }
      }
    },
    
    drawPointer(ctx, centerX, centerY, wheelRadius, angle, color) {
      const pointerLength = 30;
      const pointerWidth = 30;
      
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(angle);
      
      ctx.beginPath();
      ctx.moveTo(wheelRadius, 0);
      ctx.lineTo(wheelRadius + pointerLength, -pointerWidth / 2);
      ctx.lineTo(wheelRadius + pointerLength, pointerWidth / 2);
      ctx.closePath();
      
      ctx.fillStyle = color;
      ctx.fill();
      ctx.strokeStyle = '#333';
      ctx.lineWidth = 1;
      ctx.stroke();
      
      ctx.restore();
    },
    
    toggleSpin() {
      if (this.isDragging) return;
      if (this.isSpinning) {
        this.stopSpin();
      } else {
        this.startSpin();
      }
    },
    
    startSpin() {
      this.isSpinning = true;
      this.speed = 0.9 + Math.random() * 0.6;
      this.selectedStudent = null;
      this.hasStarted = true;
      this.animate();
    },
    
    stopSpin() {
      this.isSpinning = false;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      this.determineWinner();
    },
    
    animate() {
      if (!this.isSpinning) return;
      
      this.rotation += this.speed;
      this.speed *= 0.94;
      
      if (this.speed < 0.002 && this.speed > -0.002) {
        this.stopSpin();
        return;
      }
      
      this.drawWheel();
      this.updateSelectedStudent();
      this.animationId = requestAnimationFrame(this.animate);
    },
    
    updateSelectedStudent() {
      const displayStudents = this.displayStudents;
      if (displayStudents.length === 0) return;
      
      const anglePerStudent = (2 * Math.PI) / displayStudents.length;
      const normalizedRotation = this.rotation % (2 * Math.PI);
      
      this.selectedStudents = [];
      
      for (let i = 0; i < this.selectedCount; i++) {
        let pointerAngle;
        if (this.selectedCount === 1) {
          pointerAngle = -normalizedRotation;
        } else {
          pointerAngle = this.pointerAngles[i] - normalizedRotation;
        }
        
        let winnerIndex = Math.floor(pointerAngle / anglePerStudent);
        if (winnerIndex < 0) {
          winnerIndex += displayStudents.length;
        }
        winnerIndex = winnerIndex % displayStudents.length;
        
        this.selectedStudents.push(displayStudents[winnerIndex]);
      }
      
      if (this.selectedCount === 1) {
        this.selectedStudent = this.selectedStudents[0];
      }
    },
    
    determineWinner() {
      const displayStudents = this.displayStudents;
      if (displayStudents.length === 0) return;
      
      const anglePerStudent = (2 * Math.PI) / displayStudents.length;
      const normalizedRotation = this.rotation % (2 * Math.PI);
      
      this.selectedStudents = [];
      
      for (let i = 0; i < this.selectedCount; i++) {
        let pointerAngle;
        if (this.selectedCount === 1) {
          pointerAngle = -normalizedRotation;
        } else {
          pointerAngle = this.pointerAngles[i] - normalizedRotation;
        }
        
        let winnerIndex = Math.floor(pointerAngle / anglePerStudent);
        if (winnerIndex < 0) {
          winnerIndex += displayStudents.length;
        }
        winnerIndex = winnerIndex % displayStudents.length;
        
        this.selectedStudents.push(displayStudents[winnerIndex]);
      }
      
      if (this.selectedCount === 1) {
        this.selectedStudent = this.selectedStudents[0];
      }
    },
    
    reset() {
      this.rotation = Math.random() * 2 * Math.PI;
      this.speed = 0;
      this.isSpinning = false;
      this.selectedStudent = null;
      this.selectedStudents = [];
      this.hasStarted = false;
      this.excludedStudentIds = [];
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      this.updatePointers();
      this.drawWheel();
    },
    
    getMouseAngle(e) {
      const canvas = this.$refs.wheelCanvas;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left - canvas.width / 2;
      const y = e.clientY - rect.top - canvas.height / 2;
      let angle = Math.atan2(y, x);
      if (angle < 0) {
        angle += 2 * Math.PI;
      }
      return angle;
    },
    
    handleMouseDown(e) {
      e.preventDefault();
      
      if (e.button !== 0 && e.button !== 2) {
        return;
      }
      
      this.isDragging = true;
      this.lastMouseAngle = this.getMouseAngle(e);
      this.lastMouseTime = Date.now();
      this.lastMouseSpeed = 0;
      this.speed = 0;
      this.isSpinning = true;
      this.hasStarted = true;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      this.drawWheel();
      this.updateSelectedStudent();
    },
    
    handleMouseMove(e) {
      e.preventDefault();
      if (!this.isDragging) return;
      
      const currentTime = Date.now();
      if (currentTime - this.lastDrawTime < this.drawInterval) {
        return;
      }
      
      const deltaTime = currentTime - this.lastMouseTime;
      const currentAngle = this.getMouseAngle(e);
      let deltaAngle = currentAngle - this.lastMouseAngle;
      
      if (deltaAngle > Math.PI) {
        deltaAngle -= 2 * Math.PI;
      } else if (deltaAngle < -Math.PI) {
        deltaAngle += 2 * Math.PI;
      }
      
      if (deltaTime > 0) {
        this.lastMouseSpeed = deltaAngle / deltaTime * 100;
      }
      
      this.rotation += deltaAngle;
      this.lastMouseAngle = currentAngle;
      this.lastMouseTime = currentTime;
      this.lastDrawTime = currentTime;
      
      this.drawWheel();
      this.updateSelectedStudent();
    },
    
    handleMouseUp(e) {
      e.preventDefault();
      if (this.isDragging) {
        this.isDragging = false;
        if (Math.abs(this.lastMouseSpeed) > 0.01) {
          this.speed = this.lastMouseSpeed;
          this.animate();
        } else {
          this.isSpinning = false;
          this.determineWinner();
        }
      }
    },
    
    handleMouseLeave(e) {
      e.preventDefault();
      if (this.isDragging) {
        this.handleMouseUp(e);
      }
    },
    
    handleContextMenu(e) {
      e.preventDefault();
      return false;
    },
    
    handleClose() {
      this.reset();
      this.selectedCount = 1;
      this.dialogVisible = false;
    },
    
    updatePointers() {
      const displayStudents = this.displayStudents;
      if (displayStudents.length === 0) return;
      
      this.selectedStudent = null;
      this.selectedStudents = [];
      this.hasStarted = false;
      
      if (displayStudents.length <= this.selectedCount) {
        const compareText = displayStudents.length < this.selectedCount ? '大于' : '等于';
        this.warningMessage = `点名人数(${this.selectedCount}人)${compareText}转盘上剩余的学生人数(${displayStudents.length}人)，\n将会抽到重复的学生！`;
      } else {
        this.warningMessage = '';
      }
      
      this.pointerAngles = this.generateRandomPointers();
      this.drawWheel();
      this.updateSelectedStudent();
    },
    
    generateRandomPointers() {
      const displayStudents = this.displayStudents;
      const pointerCount = this.selectedCount;
      const anglePerStudent = (2 * Math.PI) / displayStudents.length;
      const minAngleBetweenPointers = anglePerStudent * 1.5;
      
      const pointerAngles = [];
      
      for (let i = 0; i < pointerCount; i++) {
        let angle;
        let attempts = 0;
        const maxAttempts = 1000;
        let foundValidAngle = false;
        
        do {
          angle = Math.random() * 2 * Math.PI;
          attempts++;
          if (this.isValidPointerAngle(angle, pointerAngles, minAngleBetweenPointers)) {
            foundValidAngle = true;
            break;
          }
        } while (attempts < maxAttempts);
        
        if (foundValidAngle) {
          pointerAngles.push(angle);
        } else {
          let bestAngle = Math.random() * 2 * Math.PI;
          let maxMinDistance = 0;
          
          for (let testAttempt = 0; testAttempt < 100; testAttempt++) {
            const testAngle = Math.random() * 2 * Math.PI;
            let minDistance = Infinity;
            
            for (const existingAngle of pointerAngles) {
              let angleDiff = Math.abs(testAngle - existingAngle);
              if (angleDiff > Math.PI) {
                angleDiff = 2 * Math.PI - angleDiff;
              }
              minDistance = Math.min(minDistance, angleDiff);
            }
            
            if (minDistance > maxMinDistance) {
              maxMinDistance = minDistance;
              bestAngle = testAngle;
            }
          }
          
          pointerAngles.push(bestAngle);
        }
      }
      
      return pointerAngles;
    },
    
    isValidPointerAngle(newAngle, existingAngles, minAngleBetweenPointers) {
      for (const existingAngle of existingAngles) {
        let angleDiff = Math.abs(newAngle - existingAngle);
        if (angleDiff > Math.PI) {
          angleDiff = 2 * Math.PI - angleDiff;
        }
        
        if (angleDiff < minAngleBetweenPointers) {
          return false;
        }
      }
      return true;
    },
    
    increaseCount() {
      if (this.selectedCount + 10 <= this.maxCount) {
        this.selectedCount += 10;
        this.updatePointers();
      } else {
        this.selectedCount = this.maxCount;
        this.updatePointers();
      }
    },
    
    decreaseCount() {
      if (this.selectedCount - 10 >= 1) {
        this.selectedCount -= 10;
        this.updatePointers();
      } else {
        this.selectedCount = 1;
        this.updatePointers();
      }
    },
    
    excludeCurrentStudents() {
      if (this.hasStarted && this.selectedStudents.length > 0) {
        const newExcludedIds = this.selectedStudents.map(s => s.id);
        this.excludedStudentIds = [...this.excludedStudentIds, ...newExcludedIds];
        this.updatePointers();
        this.drawWheel();
        
        if (this.displayStudents.length <= this.selectedCount) {
          const compareText = this.displayStudents.length < this.selectedCount ? '大于' : '等于';
          this.warningMessage = `点名人数(${this.selectedCount}人)${compareText}转盘上剩余的学生人数(${this.displayStudents.length}人)，\n将会抽到重复的学生！`;
        } else {
          this.warningMessage = '';
        }
      }
    },
    
    restoreStudent(studentId) {
      this.excludedStudentIds = this.excludedStudentIds.filter(id => id !== studentId);
      this.warningMessage = '';
      this.updatePointers();
      this.drawWheel();
    },
    
    restoreAllStudents() {
      this.excludedStudentIds = [];
      this.warningMessage = '';
      this.updatePointers();
      this.drawWheel();
    },
    
    setupWheelEvents() {
      const canvas = this.$refs.wheelCanvas;
      if (canvas) {
        if (this.boundEvents) {
          Object.keys(this.boundEvents).forEach(event => {
            canvas.removeEventListener(event, this.boundEvents[event]);
          });
        }
        
        const boundMouseDown = (e) => this.handleMouseDown(e);
        const boundMouseMove = (e) => this.handleMouseMove(e);
        const boundMouseUp = (e) => this.handleMouseUp(e);
        const boundMouseLeave = (e) => this.handleMouseLeave(e);
        const boundContextMenu = (e) => this.handleContextMenu(e);
        
        canvas.addEventListener('mousedown', boundMouseDown);
        canvas.addEventListener('mousemove', boundMouseMove);
        canvas.addEventListener('mouseup', boundMouseUp);
        canvas.addEventListener('mouseleave', boundMouseLeave);
        canvas.addEventListener('contextmenu', boundContextMenu);
        
        this.boundEvents = {
          mousedown: boundMouseDown,
          mousemove: boundMouseMove,
          mouseup: boundMouseUp,
          mouseleave: boundMouseLeave,
          contextmenu: boundContextMenu
        };
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setupWheelEvents();
    });
  },
  beforeDestroy() {
    const canvas = this.$refs.wheelCanvas;
    if (canvas && this.boundEvents) {
      Object.keys(this.boundEvents).forEach(event => {
        canvas.removeEventListener(event, this.boundEvents[event]);
      });
    }
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
};
</script>

<style scoped>
.lucky-draw-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.main-content {
  display: flex;
  align-items: flex-start;
  gap: 40px;
  width: 100%;
}

.left-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-top: 20px;
  min-width: 300px;
}

.count-control {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #f5f7fa;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  justify-content: center;
}

.exclude-control {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #f5f7fa;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  justify-content: space-around;
}

.count-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.right-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}

.wheel-wrapper {
  position: relative;
}

.wheel-canvas {
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  cursor: grab;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: auto;
  z-index: 1;
}

.wheel-canvas:active {
  cursor: grabbing;
}

.result-display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 600px;
}

.result-single {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.result-multiple {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
}

.result-label {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-right: 15px;
}

.result-multiple .result-label {
  margin-right: 0;
  margin-bottom: 15px;
}

.result-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pointer-color {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.result-name {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.warning-message {
  background-color: #ff0000;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  padding: 12px 20px;
  margin-top: 15px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(255, 0, 0, 0.3);
  line-height: 1.6;
  white-space: pre-line;
  display: block;
  width: 100%;
  max-width: 600px;
  box-sizing: border-box;
  overflow: hidden;
}

.result-single .result-name {
  font-size: 36px;
}

.controls {
  display: flex;
  gap: 15px;
  width: 100%;
  max-width: 600px;
  justify-content: space-around;
}

.tips {
  margin-top: 15px;
  font-size: 14px;
  color: #909399;
  text-align: center;
}

.count-control >>> .el-input-number {
  flex-shrink: 0;
}

.count-control >>> .el-input__inner {
  width: 120px !important;
}

.excluded-list-container {
  max-height: 500px;
  overflow-y: auto;
}

.empty-state {
  text-align: center;
  color: #909399;
  padding: 40px 20px;
  font-size: 16px;
}

.excluded-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.excluded-student-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f5f7fa;
  border-radius: 8px;
  transition: all 0.3s;
}

.excluded-student-item:hover {
  background: #e6f7ff;
}

.student-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.student-number {
  font-weight: bold;
  color: #409EFF;
  font-size: 14px;
}

.student-name {
  font-size: 16px;
  color: #333;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
